import React from "react";
import { ClientSelectionCard } from "../client-selection-card";
import { PracticeConnectionsCardHeader } from "../practice-connections-card-header";
import { PracticeConnectionTable } from "../practice-connections-table";
import { Button } from "../../../../ui/button";
import { SelectClientPopover } from "../select-client-popover";
import { makeStyles } from "@material-ui/core";
import useConnections from "../../../Connections/hooks/useConnections";
import useCustomPopover from "../../../../CustomPopover/hooks/useCustomPopover";

const ConnectionsMainContent = () => {
  const {
    allPractices: clients,
    canUseMultiPractice,
    handleClientSelected,
    selectedClientName,
    activateClient,
    localSelectedPractices,
    handleClickLocalPractice,
    handleUnCheckAllLocalPractices,
    handleCheckAllLocalPractices,
    handleUpdateConnections,
    practiceFilter,
    setPracticeFilter,
    filteredLocalSelectedPractices,
    clientItem,
    setClientItem,
  } = useConnections();

  const { open, anchorEl, handleClose, handleClick } = useCustomPopover();
  const id = open ? "simple-popover" : undefined;
  const practicesConnected = localSelectedPractices.filter(
    (practice) => practice.isConnected,
  );

  return (
    <main className="flex-1 overflow-auto pt-6 pb-8">
      {/* Page Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Practices Connections
        </h1>
        <p className="text-gray-500">
          Connect or disconnect your practices to update dashboard metrics
        </p>
      </div>

      <ClientSelectionCard
        activateClient={activateClient}
        selectedClientName={selectedClientName}
        id={id}
        handleClick={handleClick}
        clients={clients}
        clientItem={clientItem}
        setClientItem={setClientItem}
        handleClientSelected={handleClientSelected}
      />

      <div className="bg-white rounded-xl border border-gray-200">
        <PracticeConnectionsCardHeader
          handleCheckAllLocalPractices={handleCheckAllLocalPractices}
          practicesConnected={practicesConnected}
          handleUnCheckAllLocalPractices={handleUnCheckAllLocalPractices}
          localSelectedPractices={localSelectedPractices}
          practiceFilter={practiceFilter}
          setPracticeFilter={setPracticeFilter}
          canUseMultiPractice={canUseMultiPractice}
        />
        <PracticeConnectionTable
          localSelectedPractices={filteredLocalSelectedPractices}
          handleClickLocalPractice={handleClickLocalPractice}
        />
      </div>

      <div className="flex mt-3 w-full justify-end">
        <Button
          className={`!bg-teal-600 hover:bg-teal-800 text-white !rounded-xl !h-9 gap-2`}
          onClick={handleUpdateConnections}
          disabled={practicesConnected.length <= 0}
        >
          Update Connections ({practicesConnected?.length} selected)
        </Button>
      </div>
    </main>
  );
};

export default ConnectionsMainContent;
